
<template>
    <div>
        <router-view />
        <AuthExpiryWatcher :check-every="15000" :warn-before-seconds="0" />
        <ImpersonationBanner />
    </div>
</template>

<script setup>
import {useAuthStore} from "@/stores/auth.store";
import AuthExpiryWatcher from "./components/mics/AuthExpiryWatcher.vue";
import ImpersonationBanner from "./components/mics/ImpersonationBanner.vue";

const authStore = useAuthStore();
//const user = authStore.ensureUserIsLoggedIn();
</script>
